import gql from "graphql-tag";

const CREATE_BATCH_EXPORT_SUPPLIER_PAYMENTS_TO_ACCOUNTS = gql`
  mutation createBatchExportSupplierPaymentsToAccounts($input: BatchExportToAccountsInput!) {
    createBatchExportSupplierPaymentsToAccounts(input: $input) {
      id
    }
  }
`;
export default {
  data() {
    return {
      batchExportTask: null,
      showBatchExportTaskStatus: false,
    };
  },
  methods: {
    async batchExportToAccounts(list, name, target = "xero") {
      const input = {
        name,
        recordsIds: list.map((r) => (r.node ? r.node.id : r.id)),
        target,
      };
      try {
        const { data } = await this.$apollo.mutate({
          mutation: CREATE_BATCH_EXPORT_SUPPLIER_PAYMENTS_TO_ACCOUNTS,
          variables: { input: { ...input } },
        });
        this.batchExportTask = {
          ...data.createBatchExportSupplierPaymentsToAccounts,
        };
        this.showBatchExportTaskStatus = true;
      } catch (error) {
        const errorMsg = (error.graphQLErrors || [])
          .map((e) => e.message)
          .join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg || error.message,
          color: "error",
        });
      }
    },
    onBatchExportToAccountsComplete(result) {
      this.$store.dispatch("showAppSnackbar", {
        msg: result.taskStatus.notes,
        color: result.taskStatus.status == "ERROR" ? "error" : "success",
      });
      this.showBatchExportTaskStatus = false;
      if (this.$apollo.queries.purchaseInvoicePayments != null) {
        this.$apollo.queries.purchaseInvoicePayments.refetch();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/gt/finances/purchase-invoice-payments/batch-export-supplier-payments-to-accounts-mixin.js